
  import createMeisterIcons from '../src/createMeisterIcons';

  const Signal = createMeisterIcons("signal", [["path",{"fill":"currentColor","d":"M17.5 6.75a.75.75 0 0 0-1.5 0v11a.75.75 0 0 0 1.5 0zM11.75 10a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-1.5 0v-7a.75.75 0 0 1 .75-.75m-5 4a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75","key":"f35bc5b96c299e89feb53b6122eaa16bf2d8db72","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Signal
  